'use client';

import { ToastContainer } from 'react-toastify';

import { TOAST_CONFIG } from '../../constants/constants';
import { useClientHasRendered } from '../../helpers/hooks';

export const ClientToastContainer = () => {
  const clientHasRendered = useClientHasRendered();
  return clientHasRendered ? (
    <ToastContainer
      icon={false}
      theme="light"
      position={TOAST_CONFIG.position}
      autoClose={TOAST_CONFIG.autoClose}
    />
  ) : (
    <></>
  );
};
